import type { ReactNode } from 'react';
import FormSubmitButton from '../../../molecules/form-elements/FormSubmitButton';
import NeobetRaisedActionButtonLabel from './NeobetRaisedActionButtonLabel';
import { neobetRaisedActionButtonStyles } from '../../../../styles/components/neobetRaisedActionButton';
import { mergeSx } from '../../../../utils/styles';
import type { FormSubmitButtonPresentation } from '../../../molecules/form-elements/FormSubmitButton';

type NeobetFormSubmitButtonProps = {
  isSubmitting?: boolean;
  title: ReactNode;
} & FormSubmitButtonPresentation;

const formVariantStyles = mergeSx(
  neobetRaisedActionButtonStyles.button,
  neobetRaisedActionButtonStyles.variants.form,
);

const NeobetFormSubmitButton = ({ isSubmitting, title, sx, ...rest }: NeobetFormSubmitButtonProps) => (
  <FormSubmitButton
    isSubmitting={isSubmitting}
    title={title}
    label={<NeobetRaisedActionButtonLabel>{title}</NeobetRaisedActionButtonLabel>}
    sx={mergeSx(formVariantStyles, sx)}
    {...rest}
  />
);

export default NeobetFormSubmitButton;
